import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackCustom, packEvents } from '../utils/tracking';
import { requestOffer, PackId } from '../utils/offerBus';
interface CtaButtonProps {
  href?: string;
  children: React.ReactNode;
  variant?: 'primary' | 'ghost';
  size?: 'md' | 'lg';
  className?: string;
  icon?: React.ReactNode;
  /** Preselects this pack in the offer section before scrolling back to it. */
  offer?: PackId;
  onClick?: () => void;
}
export function CtaButton({
  href = '#offer',
  children,
  variant = 'primary',
  size = 'lg',
  className = '',
  icon,
  offer,
  onClick
}: CtaButtonProps) {
  const base = 'group inline-flex items-center justify-center gap-3 font-display font-extrabold uppercase tracking-wide transition-[transform,background-color,border-color,color] duration-150 ease-grit focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500 focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950';
  const sizing = size === 'lg' ? 'px-8 py-4 text-xl sm:text-2xl' : 'px-5 py-3 text-base';
  const look = variant === 'primary' ? 'bg-grit-500 text-ink-950 hover:bg-grit-400 active:translate-y-[2px]' : 'border-2 border-white/25 text-white hover:border-grit-500 hover:text-grit-500 active:translate-y-[2px]';

  // Scroll-to-offer buttons don't add anything to a cart, so they don't fire AddToCart.
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (offer) {
      // Go straight to this pack's buy button instead of the top of the offers.
      event.preventDefault();
      requestOffer(offer);
      trackCustom(packEvents[offer].selected, {
        source: 'cta_button'
      });
    }
    onClick?.();
  };
  return <a href={href} data-buy-intent={href === '#offer' ? 'true' : undefined} onClick={handleClick} className={`${base} ${sizing} ${look} ${className}`} data-id="element-456" data-mp="6iamhoz89y76">
      {icon}
      <span data-id="element-457" data-mp="gff9ts4t7zpk">{children}</span>
      {!icon && <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-458" data-mp="ge46ftfa0tyz" />}
    </a>;
}